import type { Theme } from '@mui/material/styles';
import { DISABLED_CONTROL_COLOR, VENDOR_LINK_COLOR, VENDOR_LINK_COLOR_DARK } from './constants';

export const vendorLinkColor = (theme: Theme) =>
  theme.palette.mode === 'dark' ? VENDOR_LINK_COLOR_DARK : VENDOR_LINK_COLOR;

export const rowLinkSx = {
  alignItems: 'center',
  color: vendorLinkColor,
  display: 'inline-flex',
  fontSize: '13px',
  fontWeight: 500,
  gap: '4px',
  justifyContent: 'flex-start',
  lineHeight: 1.4,
  minHeight: 24,
  minWidth: 0,
  padding: 0,
  textDecoration: 'none',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  '& .MuiSvgIcon-root': {
    color: 'inherit',
    fontSize: '16px',
    height: '16px',
    width: '16px',
  },
  '& .MuiButton-startIcon > *:nth-of-type(1)': {
    fontSize: '16px !important',
    height: '16px',
    width: '16px',
  },
  '& .MuiButton-startIcon': {
    margin: 0,
  },
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
  '&.Mui-disabled': {
    color: DISABLED_CONTROL_COLOR,
    textDecoration: 'none',
  },
} as const;
